<template>
  <infoBlock :title="$t('labels.system_information')" marker-color="#6AD1F4" class="profile-system-info">
    <div class="profile-block__row">
      <div class="profile-block__row-label">{{ $t('labels.employee_id') }}</div>
      <div class="profile-block__row-data">{{ user.getId()}}</div>
    </div>
    <div class="profile-block__row">
      <div class="profile-block__row-label">{{ $t('labels.user_status') }}</div>
      <div class="profile-block__row-data">{{ statusToText(user.getStatus()) }}</div>
    </div>
  </infoBlock>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  import {USER_STATUS_ACTIVE} from '@/constants';
  export default {
    props: ['user'],
    components: {
      infoBlock
    },
    methods: {
      statusToText (status) {
        switch (status) {
          case USER_STATUS_ACTIVE:
            return this.$t('labels.status_active');
          default:
            return this.$t('labels.status_closed');
        }
      }
    }
  }
</script>
<style lang="scss">
.profile-system-info {
  &:before {
    background: #6AD1F4;
  }
}
</style>